import api from '@/services/Api'

class ExpressistTransporterService {

  async getExpressistTransporterConnexionLinkById(expressistConnexionLinkId) {
    const url = '/distributor/transporter/expressist/connexion/link/' + expressistConnexionLinkId
    const response = await api.get(url)
    return response.data
  }

  async getExpressistConnexionLinkListByStoreId(storeId) {
    const url = '/distributor/transporter/expressist/connexion/link-list-by-store/' + storeId
    const response = await api.get(url)
    return response.data
  }

  async deleteExpressistConnexionLink(linkId) {
    const response = await api.delete(
      '/distributor/transporter/expressist/connexion/link/' + linkId)
    return response.data
  }

  async getAllTransporterList(){
    const url = '/distributor/transporter/expressist/list'
    const response = await api.get(url)
    return response.data
  }

  async getAllExpressistTransporterServiceByType(transporterType){
    const url = '/distributor/transporter/expressist-service/list/' + transporterType
    const response = await api.get(url)
    return response.data
  }

  async createExpressistTransporterForStore(data) {
    const url = '/distributor/transporter/expressist'
    const response = await api.post(url, data)
    return response.data
  }

  async getExpressistTransporterConnexionFullById(expressistConnexionId){
    const url = '/distributor/transporter/expressist/connexion-full/' + expressistConnexionId
    const response = await api.get(url)
    return response.data
  }

  async getExpressistTransporterConnexionLoginByLinkId(expressistLinkId){
    const url = '/distributor/transporter/expressist/connexion-login/' + expressistLinkId
    const response = await api.get(url)
    return response.data
  }

  async updateExpressistTransporterForStore(data) {
    const url = '/distributor/transporter/expressist'
    const response = await api.put(url, data)
    return response.data
  }

  async getExpressistTransporterListByContext(storeBoomerangId){
    const url = '/distributor/transporter/expressist/list/' + storeBoomerangId
    const response = await api.get(url)
    return response.data
  }

  async getExpressistTransporterById(expressistId){
    const url = '/distributor/transporter/expressist/' + expressistId
    const response = await api.get(url)
    return response.data
  }

  async getExpressistConnexionServiceList(expressist_transporter_connexion_id) {
    const url = '/distributor/transporter/expressist/connexion-service-list/' + expressist_transporter_connexion_id
    const response = await api.get(url)
    return response.data
  }

  async getPackingSlip(repairFileBoomerangId) {
    const response = await api.get(
      '/distributor/transporter/expressist/get-packing-slip/' + repairFileBoomerangId, {
      responseType: 'blob'
    })
    return response.data
  }
}

export default new ExpressistTransporterService()
